import { UserRepository } from "../../repositories/userRepository"
import { UseCase } from "../useCase"

export type SendUsersNotificationRequest = {
	emailListFile: File
	subject: string
	messageHtml: string
	attachmentFile?: File
}

export class SendUsersNotificationUseCase implements UseCase<SendUsersNotificationRequest, { message: string }> {
	private _repository: UserRepository

	constructor({ UserRepository }: { UserRepository: UserRepository }) {
		this._repository = UserRepository
	}

	exec(payload: SendUsersNotificationRequest): Promise<{ message: string }> {
		return this._repository.sendUsersNotification(payload)
	}
}
